import React from 'react';
import ReactDOM from 'react-dom';
import {createFragmentContainer, QueryRenderer} from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import { Route, Link } from "react-router-dom";

import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';

import NavDrawer from './AccountsNavDrawer'//'../../StorybookComponents/NavDrawer';

import withTheme, {theme} from '../../themes/app_theme';

import RoutesComponent from './RoutesComponent';
import environment from '../../mock_environment';
/*
user = {{
  name: 'User',
  property: "",//,
  org: "",//orgs_data[0].name,
  org_id: "",//orgs_data[0].id
}}
pathname={props.location.pathname}
environment = {environment}
suborg_change_available
link_component = {Link}
menu = {[
  {
    to: '/',
    path: '/',
    title: 'Properties',
    icon_type: 'icon-apartment'
  },
  {
    to: '/embeds',
    path: '/embeds',
    title: 'Embeds',
    icon_type: 'icon-floors'
  },
  {
    to: '/tracking',
    path: '/tracking',
    title: 'Tracking',
    icon_type: 'icon-timeline'
  },
  {
    to: '/subscriptions',
    path: '/subscriptions',
    title: 'Subscriptions',
    icon_type: 'icon-multiple-11'
  },
  {
    to: '/accounts',
    path: '/accounts',
    title: 'Accounts',
    icon_type: 'icon-single-02'
  }
]}
*/
export default React.memo(props => (
  <Route
    path="/"
    render={props => (
      <NavDrawer pathname={props.location.pathname}>
        <RoutesComponent pathname = {props.location.pathname} />
      </NavDrawer>
    )}
  />
));
